type SortAndMapOptions<T, R> = {
  /** May be Immer-frozen; must not be sorted in place. Null/undefined treated as empty. */
  array: T[] | null | undefined;
  sortKey: keyof T;
  mapCallback: (item: T, index: number) => R;
};

export function sortAndMap<T, R>({
  array,
  sortKey,
  mapCallback
}: SortAndMapOptions<T, R>): R[] {
  // Copy before sort — input may be Immer-frozen Redux state; sort mutates in place.
  const copy = array == null ? [] : Array.from(array);
  return copy
    .sort((a, b) => (a[sortKey] > b[sortKey] ? 1 : -1))
    .map(mapCallback);
}
